import { InfoCircleOutlined } from '@ant-design/icons';
import { Form, Input, Tooltip } from 'antd';
import { useEmployeeGeneralDataForm } from '../EmployeeGeneralDataFormContext';

/** Default timesheet comment and other remarks. */
export default function EmployeeRemarksFields() {
  const { inSection, otherRemarksKeys, otherRemarksState, t } =
    useEmployeeGeneralDataForm();

  return (
    <>
      <Form.Item
        hidden={!inSection('napomene')}
        name={['allowances', 'defaultTimesheetComment']}
        label={
          <span>
            <Tooltip
              title={t('defaultTimesheetCommentTooltip', { ns: 'forms' })}
            >
              <InfoCircleOutlined className="mr-2 text-base text-zinc-400" />
            </Tooltip>
            {t('defaultTimesheetComment', { ns: 'forms' })}
          </span>
        }
      >
        <Input.TextArea
          rows={3}
          placeholder={t('defaultTimesheetCommentPlaceholder', { ns: 'forms' })}
        />
      </Form.Item>

      {otherRemarksState?.visible && (
        <Form.Item
          hidden={!inSection('napomene')}
          name={otherRemarksKeys}
          label={t('otherRemark', { ns: 'forms' })}
          rules={[
            { required: false },
            {
              min: 10,
              message: t('formValidation.minLength', {
                count: 10,
                ns: 'forms',
              }),
            },
          ]}
        >
          <Input.TextArea
            disabled={otherRemarksState?.disabled}
            rows={6}
            placeholder={t('otherRemark', { ns: 'forms' })}
          />
        </Form.Item>
      )}
    </>
  );
}
